import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["button"]

  connect() {
    this.buttonTargets.forEach((btn) => {
      btn.addEventListener("click", (event) => {
        const currentThreadId = document.querySelector(".thread-body")?.dataset.currentThreadId
        if (currentThreadId) {
          const url = new URL(btn.href)
          url.searchParams.append("current_thread_id", currentThreadId)
          btn.href = url.toString()
        }
      })
    })
  }
}
